import { notifUtils } from "../components/NotifUtils/NotifUtils";
import AuthService from "../Services/AuthService/AuthService";
// import hotelJson from "assets/json/sidebar.json";
// import firebase from "services/Firebase";
// import _ from "lodash";
// import qiscus from "components/utils/QiscusSDKCore";

export const onSubmitLogin = async (
  store,
  email,
  password,
  token,
  isScanner = false
) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  AuthService.login(email, password, token)
    .then(async (response) => {
      const userData = response.data;
      const isLoading = false;
      const status = 200;
      const defaultPage = userData.result.role.default_page.replace(
        /^\/+/g,
        ""
      );

      const newData = userData;
      newData.result.chat_handler = false;

      let roomId = "";
      const user = userData?.result;
      switch (user?.type) {
        case "tenant":
          roomId = `shop_tenant_${user?.tenant?.id}`;
          break;

        // default:
        //   roomId = `shop_staff_operational_${user?.operational?.level}_${user?.operational?.id}`;
        //   break;
        default:
          roomId = `shop_tenant_${user?.operational?.level}${user?.operational?.id}00${user?.id}`;
          break;
      }

      localStorage.setItem("token", userData.result.token);
      localStorage.setItem("user", JSON.stringify(userData.result));
      localStorage.setItem("roomId", roomId);
      localStorage.removeItem("lastVisit");

      store.setState({ userData, isLoading, status });
      window.location.href = `/${defaultPage || "home"}`;
    })
    .catch((error) => {
      const status = error.response ? error.response.status : "";
      const message = error.response ? error.response.data.message : "";
      const isLoading = false;
      store.setState({ isLoading, status, message });
    });
};

export const onForgotPassword = async (store, email) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  AuthService.forgotPassword({ email })
    .then(async (response) => {
      const isLoading = false;
      const status = 200;

      store.setState({ isLoading, status });
      notifUtils("New Password Send To Your Email", "success");
      setTimeout(() => {
        window.location.href = `/login`;
      }, 4000);
    })
    .catch((error) => {
      const status = error.response ? error.response.status : "";
      const message = error.response ? error.response.data.message : "";
      const isLoading = false;
      store.setState({ isLoading, status, message });
    });
};
